var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ConnectionGroupMapping"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v("Search Group Connections")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Group City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-home'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('destinationcityid')
    },
    attrs: {
      "options": _vm.cityList,
      "selected-option": _vm.destinationcityObjData,
      "name": "destinationcityid",
      "placeholder": "Select City"
    },
    on: {
      "select": _vm.selectedDestination
    },
    model: {
      value: (_vm.destinationcityid),
      callback: function($$v) {
        _vm.destinationcityid = $$v
      },
      expression: "destinationcityid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationcityid')),
      expression: "errors.has('destinationcityid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destinationcityid')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.cityLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Group"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('groupid')
    },
    attrs: {
      "options": _vm.groupList,
      "selected-option": _vm.groupTypeObjData,
      "name": "groupid",
      "placeholder": "Select Group"
    },
    on: {
      "select": _vm.selectedGroupType
    },
    model: {
      value: (_vm.groupid),
      callback: function($$v) {
        _vm.groupid = $$v
      },
      expression: "groupid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('groupid')),
      expression: "errors.has('groupid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('groupid')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Type"), _c('span', {
    staticClass: "text-danger"
  })]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-home'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.allBagTypes,
      "name": "selectedBag",
      "id": "selectedBag",
      "label": "text",
      "track-by": "id",
      "placeholder": "Select BagType",
      "show-labels": false,
      "multiple": true,
      "max-height": 300,
      "clear-on-select": false
    },
    on: {
      "select": _vm.selectedBagType
    },
    model: {
      value: (_vm.selectedBag),
      callback: function($$v) {
        _vm.selectedBag = $$v
      },
      expression: "selectedBag"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.bagTypeError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Parent Hub"), _c('span', {
    staticClass: "text-danger"
  })]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-automobile'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.parentHubList,
      "name": "parentHub",
      "label": "hubname",
      "track-by": "hubname",
      "placeholder": "Select ParentHub",
      "show-labels": false,
      "multiple": false,
      "max-height": 300,
      "clear-on-select": false,
      "limit": 2
    },
    on: {
      "select": _vm.selectParentHub
    },
    model: {
      value: (_vm.parentHub),
      callback: function($$v) {
        _vm.parentHub = $$v
      },
      expression: "parentHub"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.parentHubError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "groupconnectionfooter form-actions",
    staticStyle: {
      "text-align": "right!important"
    }
  }, [_c('button', {
    staticClass: "common-danger",
    staticStyle: {
      "margin-top": "40px",
      "margin-left": "510px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")])])])])])], 1)])], 1)]), _vm._v(" "), (_vm.showReplicationOption) ? _c('div', {
    staticClass: "card mb-3",
    staticStyle: {
      "border": "2px solid #28a745"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v("No connections are currently selected. Would you like to replicate connection mappings from an existing group with the same type and route mode?")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Select Source Group to Replicate From:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.replicableGroups,
      "label": "text",
      "track-by": "value",
      "placeholder": "Choose a group to copy connection mappings from",
      "show-labels": false,
      "loading": _vm.isLoadingReplication
    },
    model: {
      value: (_vm.selectedSourceGroup),
      callback: function($$v) {
        _vm.selectedSourceGroup = $$v
      },
      expression: "selectedSourceGroup"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "flex",
      "align-items": "flex-end"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedSourceGroup || _vm.isLoadingReplication
    },
    on: {
      "click": _vm.replicateFromGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  }), _vm._v(" "), (_vm.isLoadingReplication) ? _c('span', [_vm._v("Replicating...")]) : _c('span', [_vm._v("Replicate Connections")])])])])])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingtable
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingtable = $event
      }
    }
  }), _vm._v(" "), _c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v(" Connection Group Mapping List")]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitHub('hubsave')
      }
    }
  }, [_c('div', {
    style: (_vm.connectionDestList.length > 10 ? 'overflow: auto; height: 380px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "height": "10px"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllHub),
      expression: "checkAllHub"
    }],
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "0.5%"
    },
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllHub) ? _vm._i(_vm.checkAllHub, null) > -1 : (_vm.checkAllHub)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkAllHub,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllHub = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllHub = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllHub = $$c
        }
      }, _vm.checkHub]
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bagging Pattern")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Mapped")])])]), _vm._v(" "), _c('tbody', [(_vm.connectionDestList.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.connectionDestList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.isselected),
        expression: "data.isselected"
      }],
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "0.5%"
      },
      attrs: {
        "type": "checkbox",
        "id": "all"
      },
      domProps: {
        "checked": Array.isArray(data.isselected) ? _vm._i(data.isselected, null) > -1 : (data.isselected)
      },
      on: {
        "change": [function($event) {
          var $$a = data.isselected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(data, "isselected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(data, "isselected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(data, "isselected", $$c)
          }
        }, function($event) {
          return _vm.updateselected()
        }]
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtypes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.isbaggingpattern),
        expression: "data.isbaggingpattern"
      }],
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "0.5%"
      },
      attrs: {
        "type": "checkbox",
        "id": "all"
      },
      domProps: {
        "checked": Array.isArray(data.isbaggingpattern) ? _vm._i(data.isbaggingpattern, null) > -1 : (data.isbaggingpattern)
      },
      on: {
        "change": function($event) {
          var $$a = data.isbaggingpattern,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(data, "isbaggingpattern", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(data, "isbaggingpattern", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(data, "isbaggingpattern", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Mapped Hubs"
      },
      on: {
        "click": function($event) {
          return _vm.getHubMappedListData(data)
        }
      }
    })])])
  })], 2)])]), _vm._v(" "), (_vm.connectionDestList.length > 0) ? _c('div', {
    staticClass: "card-footer",
    staticStyle: {
      "padding": "0.25rem"
    }
  }, [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-left": "90%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]) : _vm._e()])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.confirmationModal = false
      }
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to map these connections to " + _vm._s(_vm.groupDisplayName) + "?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mapMultipleHubsToConnection
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.showHubsModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Hubs List"
    },
    model: {
      value: (_vm.showHubsModal),
      callback: function($$v) {
        _vm.showHubsModal = $$v
      },
      expression: "showHubsModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Mapped Hubs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeHubsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status ")])])]), _vm._v(" "), _c('tbody', [(_vm.mappedHubCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No Hub Mapped")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mappedHUbsList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isactive == true) ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusHublistData(data)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.isactive == false) ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusHublistData(data)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeHubsModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.hubStatusModal = false
      }
    },
    model: {
      value: (_vm.hubStatusModal),
      callback: function($$v) {
        _vm.hubStatusModal = $$v
      },
      expression: "hubStatusModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusHubModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to " + _vm._s(_vm.changestatusHub) + " this hub for the given connection?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeMappedHubStatus, function($event) {
        _vm.hubStatusModal = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusHubModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header bg-success text-white"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-copy"
  }), _vm._v(" Replicate Connection Mapping")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640b41c0","hasScoped":true}!./src/views/components/groupnew/ConnectionGroupMapping/ConnectionGroupMapping.html
// module id = 1933
// module chunks = 2